/* Copy do detalhe de submissão de pack (PUB-11 / ADR-0462): breadcrumb, estados de erro/loading e
   as abas do detalhe. O conteúdo de cada card (`SubmissionOverviewCard`, `ScanFindingsCard`, etc.)
   é componente externo — fora do escopo desta área. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface PackSubmissionDetailContent {
  readonly breadcrumbAriaLabel: string;
  readonly submissionsBreadcrumb: string;
  readonly fallbackTitle: string;
  readonly notFoundError: string;
  readonly overviewTab: string;
  readonly scanTab: string;
  readonly timelineTab: string;
  readonly versionsTab: string;
}

const PACK_SUBMISSION_DETAIL_CONTENT: Bilingual<PackSubmissionDetailContent> = {
  'pt-BR': {
    breadcrumbAriaLabel: 'Trilha',
    submissionsBreadcrumb: 'Submissões',
    fallbackTitle: 'Submissão',
    notFoundError: 'Submissão não encontrada ou indisponível.',
    overviewTab: 'Visão geral',
    scanTab: 'Scan',
    timelineTab: 'Histórico',
    versionsTab: 'Versões',
  },
  'en-US': {
    breadcrumbAriaLabel: 'Breadcrumb',
    submissionsBreadcrumb: 'Submissions',
    fallbackTitle: 'Submission',
    notFoundError: 'Submission not found or unavailable.',
    overviewTab: 'Overview',
    scanTab: 'Scan',
    timelineTab: 'History',
    versionsTab: 'Versions',
  },
};

export const usePackSubmissionDetailContent = (): PackSubmissionDetailContent =>
  useBilingual(PACK_SUBMISSION_DETAIL_CONTENT);
